<au-close-button (closeCallback)="close()" />
<div class="ai-chat-workspace-container" [class.fullscreen]="isFullscreen$ | async">
	<chat-list />
	<chat-conversation-area />
</div>
